<template>
  <div class="header-back">
    <div class="wrap border-bottom-1px">
      <div
        class="left"
        @click="goBack"
      >
        <i class="iconfont iconicon-test40" />{{ $t('message["282"]') }}
      </div>

      <div class="center">
        <slot name="center">
          {{ title }}
        </slot>
        <slot name="statistic" />
      </div>

      <div class="right">
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    goPath: {
      type: [String, Object],
      default: () => { }
    }
  },
  methods: {
    goBack () {
      if (!this.goPath) {
        this.$emit('back')
      } else if (this.$toType(this.goPath) === 'string') {
        this.$router.push(this.goPath)
      } else if (this.$toType(this.goPath) === 'object') {
        if (!this.goPath.path) {
          this.$emit('back')
        } else {
          this.$router.push(this.goPath)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-back {
  height: 46px;
  // margin-bottom: 10px;
  .wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    width: 375px;
    height: 46px;
    line-height: 46px;
    padding: 0 6px;
    background-color: #fff;
  }
  .left {
    width: 20%;
    color: #5077aa;
    font-size: 16px;
    .iconfont {
      margin-right: 10px;
    }
  }
  .center {
    flex: 1;
    text-align: center;
    width: 217px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 600;
  }
  .right {
    width: 20%;
    text-align: right;
  }
}
</style>
